import { I16DIMADOUCISSEURECS_State } from '@batical/types/src'

const I16DIMADOUCISSEURECS: I16DIMADOUCISSEURECS_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_thEauVille: 0.0,
  in_thSouhaite: 0.0,
  in_consommation: 0.0,
  cpcTraitementLitreResine_uuid: '2',
  in_resineSouhaite: 0.0,
  res_cpcTraitementResine: 0.0,
  res_traitementPrevoir: 0.0,
  res_freqRegen: 0.0,
  res_consoSalt: 0.0,
  res_consoEauRenvoie: 0.0,
  res_tauxSodiumEau: 0.0,
  mode: 'none',
  calcul_code: 'I16DIMADOUCISSEURECS'
}

export default I16DIMADOUCISSEURECS
